export const animationVariants = {
  hidden: { y: 60 },
  show: {
    y: 0,
    transition: { duration: 0.3 },
  },
};
